import React, { useEffect, useRef } from 'react';

import { bemCssModules } from '@utils';

import { globalActions, useStore } from '@modules';

import style from './Captcha.scss';

export type TCaptcha = {
  onSuccess?: (code: string | null) => void;
  className?: string;
};

const cn = bemCssModules(style, 'Captcha');

const Captcha: CustomFC<TCaptcha> = ({ className, onSuccess }) => {
  const captchaRef = useRef<HTMLDivElement>(null);
  const [{ global }, dispatch] = useStore();
  const { isShowCaptcha } = global;

  useEffect(() => {
    if (typeof (window.grecaptcha || {}).render === 'function') {
      window.grecaptcha.render(captchaRef.current, {
        sitekey: CONST.recaptchaKey,
        callback: code => {
          dispatch(globalActions.setCaptcha(code || ''));
          if (typeof onSuccess === 'function') {
            onSuccess(code);
          }
        },
      });
    }
  }, []);

  if (!isShowCaptcha) return null;

  return <div className={cn(null, [className])} ref={captchaRef} />;
};

export default Captcha;
